import {
  Box,
  Dialog,
  DialogProps,
  IconButton,
  Theme,
  useMediaQuery,
} from "@mui/material";
import { X as CloseIcon } from "lucide-react";
import { FC, ReactNode } from "react";

const defaultPaperSx: DialogProps["sx"] = {
  "& .MuiDialog-paper": {
    backgroundColor: "brandBackground.primary",
    borderRadius: 3,
    py: 2,
    pb: 3,
  },
};

const mobilePaperSx: DialogProps["sx"] = {
  "& .MuiDialog-paper": {
    backgroundColor: "brandBackground.primary",
    borderRadius: 0,
    py: 1,
    pb: 2,
    m: 0,
    maxHeight: "100%",
    maxWidth: "100%",
    width: "100%",
    height: "100%",
  },
};

export interface AppDialogProps extends DialogProps {
  children: ReactNode;
}

const AppDialog: FC<AppDialogProps> = ({
  sx,
  fullWidth = true,
  onClose,
  children,
  ...rest
}) => {
  const isMobile = useMediaQuery<Theme>((t) => t.breakpoints.down("sm"));

  return (
    <Dialog
      {...rest}
      onClose={onClose}
      fullWidth={fullWidth}
      fullScreen={isMobile}
      sx={{
        ...(isMobile ? mobilePaperSx : defaultPaperSx),
        ...(typeof sx === "object" && sx ? sx : {}),
      }}
    >
      {onClose && (
        <Box sx={{ position: "sticky", top: 0, zIndex: 2, height: 0 }}>
          <IconButton
            aria-label="Close"
            onClick={(e) => onClose(e, "escapeKeyDown")}
            size="small"
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              bgcolor: "grey.200",
              "&:hover": { bgcolor: "grey.300" },
            }}
          >
            <CloseIcon size={20} />
          </IconButton>
        </Box>
      )}
      {children}
    </Dialog>
  );
};

export default AppDialog;
